export default __webpack_public_path__ + "graphics/mastercard.962821ec.jpg";